/* eslint-disable no-console */
import { view } from '@esui/core';
import { HSTack } from '@esui/core/layout/index.js';
import { html, svg } from 'lit';
import { DemoPage, Section } from '../@demo/utils.js';
import { IconButtonToggle, OffIcon, OnIcon } from './index.js';

export const [IconButtonToggleDemo] = view('icon-button-toggle-demo', {
  template() {
    return DemoPage(
      Section(
        '',
        HSTack(
          IconButtonToggle()
            .onIcon('sentiment_very_satisfied')
            .offIcon('sentiment_very_dissatisfied'),

          IconButtonToggle(
            OnIcon(
              slot => svg`
                <svg slot=${slot} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M0 0h24v24H0z" fill="none"/><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/></svg>
                `
            ),
            OffIcon(
              slot =>
                svg`<svg slot=${slot} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="none" d="M0 0h24v24H0V0zm0 0h24v24H0V0z"/><path d="M16.59 7.58L10 14.17l-3.59-3.58L5 12l5 5 8-8zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"/></svg>`
            )
          ),

          IconButtonToggle(
            OnIcon(
              slot =>
                html`<img
                  alt="onIcon"
                  slot=${slot}
                  src="https://picsum.photos/id/28/24/24"
                />`
            ),

            OffIcon(
              slot =>
                html`<img
                  alt="offIcon"
                  slot=${slot}
                  src="https://picsum.photos/id/141/24/24?grayscale"
                />`
            )
          ),

          IconButtonToggle()
            .onIcon('sentiment_very_satisfied')
            .offIcon('sentiment_very_dissatisfied')
            .disabled(),

          IconButtonToggle()
            .onIcon('sentiment_very_satisfied')
            .offIcon('sentiment_very_dissatisfied')
            .color('tomato')
        ).gridGap('3rem')
      )
    );
  },
});
